import { all, fork } from "redux-saga/effects";
import reportCommentsSaga from "./reportComments/sagas";

export function* rootSaga() {
	yield all([fork(reportCommentsSaga)]);
}
